<script>
import HeaderNonAuth from '@components/navigation/HeaderNonAuth';
import Footer from '@components/navigation/Footer';

export default {
  components: {
    HeaderNonAuth,
    Footer,
  },
  mounted() {
    if (window.zE) {
      window.zE('webWidget', 'hide');
    }
  },
};
</script>

<template>
  <div class="min-h-screen bg-grey-lighter flex flex-1 flex-col">
    <HeaderNonAuth />
    <slot />
    <Footer />
  </div>
</template>

<style lang="scss" module>
</style>
